import { render } from "./ClientRequests.vue?vue&type=template&id=a20533da&scoped=true&ts=true"
import script from "./ClientRequests.vue?vue&type=script&lang=ts"
export * from "./ClientRequests.vue?vue&type=script&lang=ts"

import "./ClientRequests.vue?vue&type=style&index=0&id=a20533da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a20533da"]])

export default __exports__